<script setup lang="ts">
const props = defineProps<{
  items: {
    component: string
    _uid: string
  }[]
  background?: string
  margin?: string
  gap?: string
  anchor?: string
  mediumWidth?: boolean
}>()
const margin = (() => {
  return props.margin === 'min' ? 'py-2.5 sm:py-5' : props.margin === 'sm' ? 'py-35px sm:py-70px' : 'py-70px sm:py-140px'
})()
const gap = (() => {
  return props.gap === 'min' ? 'gap-2.5 sm:gap-5' : props.gap === 'sm' ? 'gap-35px sm:gap-70px' : 'gap-70px sm:gap-140px'
})()
</script>

<template>
  <div :id="anchor || undefined" :class="[background, margin]">
    <StoryblokContent class="flex-col flex content-container" :class="[gap, { 'max-w-760px': mediumWidth }]" :items="items" />
  </div>
</template>
